import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setCart } from "../../redux/cart";
import { getCart } from "../../services/cart";
import { cartDataMapper } from "../../helpers/dataMapper";
import { CART_CRUMBS } from "../../constants/crumbs";
import EmptyCart from "./EmptyCart/EmptyCart";
import PortalBreadcrumb from "../UI/Breadcrumb/PortalBreadcrumb/PortalBreadcrumb";
import Loading from "../UI/Loading/Loading";
import CartItems from "./CartItems/CartItems";
import Checkout from "./Checkout/Checkout";
import classes from "./Cart.module.css";

const Cart = () => {
  const [isCartLoading, setIsCartLoading] = useState(true);
  const [cartLoadingError, setCartLoadingError] = useState("");
  const [cart, setCartState] = useState();

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchCart = async () => {
      try {
        setIsCartLoading(true);
        setCartLoadingError("");
        const response = await getCart();
        const { cart } = response.data;
        const { skuList, bundleList, cartSize } = cart;
        setCartState(cart);
        dispatch(setCart(cartDataMapper(skuList, bundleList, cartSize)));
      } catch (err) {
        setCartLoadingError("حدث خطأ اثناء تحميل محتوبات العربة");
      } finally {
        setIsCartLoading(false);
      }
    };
    fetchCart();
    // eslint-disable-next-line
  }, []);

  return (
    <div className={classes["cart"]}>
      <PortalBreadcrumb paths={CART_CRUMBS} />
      {isCartLoading ? (
        <Loading className={classes["cart__loading"]} />
      ) : cartLoadingError ? (
        <EmptyCart />
      ) : cart.skuList.length === 0 && cart.bundleList.length === 0 ? (
        <EmptyCart />
      ) : (
        <section className={classes["cart__content-wrapper"]}>
          <div className={classes["cart__main-content"]}>
            <CartItems
              skus={cart.skuList}
              bundles={cart.bundleList}
              setCartState={setCartState}
            />
          </div>
          <Checkout
            skus={cart.skuList}
            bundles={cart.bundleList}
            subTotal={cart.subTotal}
            discount={cart.discount}
            total={cart.totalPrice}
          />
        </section>
      )}
    </div>
  );
};

export default Cart;
